export class WorkflowVendorEditRawDto {
    workflowId: number;
    status: string;
    communityId: number;
    payeeType: string;
    payeeCode: string;
    hasNotes: boolean;
}
